import React from "react";
import { 
  Element,
  animateScroll as scroll,
  scroller 
} from 'react-scroll';
import Fade from 'react-bootstrap/Fade';
import { isFormAttributeSelectableType } from '../shared/form_attribute_utils';
import 
  APP_CONSTANTS, {
    RULE_TYPES,
    MULTIPLE_TARGET_RULE_TYPES
  } from '../shared/constants/app_constants';

const formRuleTypeLead = {
  value_setting: {
    lead: "<b>SET VALUE</b> of an attribute (value setting rule)",
    verb: "set value"
  },
  hiding: {
    lead: "<b>HIDE</b> attributes <i>conditionally</i> (hiding rule)",
    verb: "hide"
  },
  locking: {
    lead: "make attributes <b>READ ONLY</b> <i>conditionally</i> (locking rule)",
    verb: "lock"
  },
  filtering: {
    lead: "<b>HIDE OPTIONS</b> available for an attribute (filtering rule)",
    verb: "hide options"
  },
  validating: {
    lead: "<span class='font-weight-normal'>Mark an input's value as being <b>INVALID</b> <i>conditionally</i> (validating rule)<span>",
    verb: "validate"
  },
}

function FormAttributeRuleTargetButton(props) {
  const fa = props.formAttribute;
  const isTargetAttribute = props.isTargetAttribute; // targetAttrIds.includes(fa.id);
  const disableTargetFormAttribute = props.isTargetable; // this.isFormAttributeTargetable(fa, ruleType) === false;
  const targetClass = isTargetAttribute ? 'btn-primary' : 'btn-light';
  return (
    <React.Fragment key={fa.uuid}>
      <button
        className={`btn btn-lg form-attribute-toggle ${targetClass}`}
        onClick={() => {
          props.onClickAction(fa.id);
        }}
        disabled={disableTargetFormAttribute}
        type="button">{fa.name}</button>
      {
        isTargetAttribute && disableTargetFormAttribute === false
        ? <input type="hidden" key={fa.id} name="form_rule[target_attribute_ids][]" value={fa.id} />
        : undefined 
      }
    </React.Fragment>
  );
}

function SubmitButtonAsFATargetButton(props) {
  const isTargetAttribute = props.target_submit_button;
  const disableTargetFormAttribute = props.isTargetable;
  const targetClass = isTargetAttribute ? 'btn-primary' : 'btn-light';
  const targetSubmitButtonValue = props.target_submit_button ? "1" : "0";
  return (
    <>
      <button
        className={`btn btn-lg form-attribute-toggle ${targetClass}`}
        onClick={props.onClickAction}
        disabled={disableTargetFormAttribute}
        type="button">
          Submit button</button>
      <input 
          type="hidden"
          name="form_rule[target_submit_button]" 
          value={targetSubmitButtonValue} />
    </>
  );
}

export default class FormRuleHelper extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      form_rule_type: undefined,
      target_attribute_ids: [],
      displayMultipleTargetWarning: false,
      target_submit_button: false
    }
  }

  allowMultipleTargets = (rule_type) => {
    return MULTIPLE_TARGET_RULE_TYPES.includes(rule_type);
  }

  createMarkup = (string) => {
    return {__html: string};
  }

  /**
   * returns 
   * @param {*} formAttribute - form attribute
   * @param {*} ruleType 
   * @returns {boolean} 
   */
  isFormAttributeTargetable = (formAttribute, ruleType) => {
    let isFATargetable = false;
    switch (ruleType) {
      // no rule type selected, don't allow
      case undefined:
        isFATargetable = false;
        break;
      // All attributes are hideable
      case RULE_TYPES.HIDING:
        isFATargetable = true;
        break;
      // editable form attributes, exclude non input
      case RULE_TYPES.LOCKING:
      case RULE_TYPES.VALIDATING:
        isFATargetable = [
          APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.FREEFORM,
          APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT,
          APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT,
          APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.DATEPICKER
        ].includes(formAttribute.form_attribute_type);
        break;
      // allow for all inputs to change, including noninput like STATIC HTML
      case RULE_TYPES.VALUE_SETTING:
        isFATargetable = [
          APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.FREEFORM,
          APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT,
          APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT,
          APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.DATEPICKER,
          APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.NON_INPUT // this is new
        ].includes(formAttribute.form_attribute_type);
        break;
      // only selectable form attributes, aka FA with options
      case RULE_TYPES.FILTERING:
        isFATargetable = [
          APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT,
          APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT
        ].includes(formAttribute.form_attribute_type);
        break;
      default:
        console.warn('unaccounted for RULE TYPE', ruleType)
    }
    return isFATargetable;
  }

  scrollToTargetAttributes = () => {
    scroller.scrollTo('set-target-attributes', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart'
    })
  }

  setFormRuleType = (ruleType) => {
    let formRuleHelperState = {
      ...this.state,
      form_rule_type: ruleType
    };
    if (
      this.allowMultipleTargets(ruleType) === false 
      && this.state.target_attribute_ids.length > 1
    ){ //reset target attributes because only hiding and locking form rules can have multiple targets
      formRuleHelperState.target_attribute_ids = [];
      formRuleHelperState.displayMultipleTargetWarning = true;
    }

    // if target attribute is not a selectable AND form rule type is filtering then unselect this
    if (ruleType === RULE_TYPES.FILTERING && this.state.target_attribute_ids.length > 0) {
      const targetAttributeId = this.state.target_attribute_ids[0];
      const targetFormAttribute = this.props.keenform.form_attributes.find(fa => fa.id === targetAttributeId);
      if ( isFormAttributeSelectableType(targetFormAttribute.form_attribute_type) === false ){
        formRuleHelperState.target_attribute_ids = [];
        console.log('unset this target form attribute');
      }
    }
    this.setState(formRuleHelperState);
    this.scrollToTargetAttributes();
  }

  toggleSubmitButtonAsTarget = () => {
    this.setState({
      target_submit_button: !this.state.target_submit_button
    });
  }


  /**
   * sets state of target attribute, add or remove from state
   * @param {integer} targetAttributeId - id of target attribute
   */
  toggleTargetFormAttribute = (targetAttributeId) => {
    let targetAttributeIds = [...this.state.target_attribute_ids];
    switch (this.state.form_rule_type) {
      // allows for multiple target attribute ids
      case RULE_TYPES.HIDING:
      case RULE_TYPES.LOCKING:
        if (targetAttributeIds.includes(targetAttributeId)) { // remove this targetAttributeId
          targetAttributeIds = targetAttributeIds.filter(faid => faid !== targetAttributeId);
        } else { // add this targetAttributeId
          targetAttributeIds = this.state.target_attribute_ids.concat([targetAttributeId]);
        }
        break;
      // only allows 1 target attribute id
      case RULE_TYPES.VALUE_SETTING:
      case RULE_TYPES.FILTERING:
      case RULE_TYPES.VALIDATING:
        targetAttributeIds = [targetAttributeId];
        break;
      default:
        console.warn('in toggleTargetFormAttribute, this rule type is unaccounted for', this.state);
    }

    this.setState({
      target_attribute_ids: targetAttributeIds
    });
  }

  render() {
    const ruleType = this.state.form_rule_type;
    const ruleLead = formRuleTypeLead[this.state.form_rule_type];
    const ruleVerb = ruleLead ? ruleLead.verb : "?";

    // enable next button IF this.state.form_rule_type is not blank AND
    // (this.state.target_attribute_ids.length > 0 || this.state.target_submit_button == true)
    let nextButtonDisabled = true;
    if (this.state.form_rule_type) {
      nextButtonDisabled = this.state.target_attribute_ids.length == 0 && this.state.target_submit_button == false;
    }
    
    return (
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="tab-container">
            <div className="question-set-rule-type">
            <h4 className="color-dark-blue"><strong>What kind of rule <u>action</u> do want to create?</strong></h4>
              {Object.keys(formRuleTypeLead).map(rule_type => {
                return (
                  <button
                    key={rule_type}
                    className={`btn btn-xl btn-block ${this.state.form_rule_type === rule_type ? 'btn-primary' : 'btn-light'}`}
                    onClick={() => { 
                      this.setFormRuleType( rule_type );
                      this.scrollToTargetAttributes();
                    }}
                    type="button">
                      <span
                        className="font-weight-normal"
                        dangerouslySetInnerHTML={this.createMarkup(formRuleTypeLead[rule_type].lead)} />
                  </button>
                );
              })}
              { this.state.form_rule_type 
                ? <input
                    readOnly={true}
                    type="hidden" 
                    name="form_rule[rule_type]" 
                    value={this.state.form_rule_type} />
                : undefined
              }
            </div>
          
            <div
              id="target-attributes-selector">
              <Element name="set-target-attributes" className="element">
              { this.allowMultipleTargets(ruleType)
                ? <h4 className="color-dark-blue"><strong>Select all form attributes to {ruleVerb} (required)</strong></h4>
                : <h4 className="color-dark-blue"><strong>Select a form attribute to {ruleVerb} (required)</strong></h4>
              }
              </Element>
              <Fade
                mountOnEnter={true}
                unmountOnExit={true}
                in={this.state.displayMultipleTargetWarning && !this.allowMultipleTargets(this.state.form_rule_type) }>
                <div key={99} className="alert alert-warning" role="alert">
                  <i className="fas fa-info-circle"></i> &nbsp;
                  A { this.state.form_rule_type ? this.state.form_rule_type.replace('_', ' ') : 'tbd' } rule can only have a single target attribute
                </div>
              </Fade>
              <Fade
                mountOnEnter={true}
                unmountOnExit={true}
                in={ruleType === RULE_TYPES.FILTERING }>
                <div className="alert alert-warning" role="alert">
                  <i className="fas fa-info-circle"></i> &nbsp;
                  Target attributes for filtering form rules can only be set to for an attribute that has options (i.e. select/checkbox). All other form attributes are disabled.
                </div>
              </Fade>
              {
                this.props.keenform.form_attributes
                  .filter(fa => fa.form_attribute_type !== APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.INLINE_STYLE )
                  .map(fa => {
                    const targetAttrIds = this.state.target_attribute_ids;
                    const isTargetAttribute = targetAttrIds.includes(fa.id);
                    const disableTargetFormAttribute = this.isFormAttributeTargetable(fa, ruleType) === false;
                    return ( 
                      <FormAttributeRuleTargetButton
                          key={fa.uuid}
                          formAttribute={fa}
                          isTargetAttribute={isTargetAttribute}
                          isTargetable={disableTargetFormAttribute}
                          onClickAction={() => {
                            this.toggleTargetFormAttribute(fa.id);
                          }} />                     
                    );
                })
              }
              <SubmitButtonAsFATargetButton 
                isTargetable={this.state.form_rule_type != RULE_TYPES.HIDING}
                onClickAction={this.toggleSubmitButtonAsTarget}
                target_submit_button={this.state.target_submit_button}
              />
            </div>
            <button 
              type="submit"
              disabled={ nextButtonDisabled }
              className="btn btn-lg btn-block btn-info">
              NEXT <i className="fas fa-chevron-circle-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>);
  }
}
